module.exports = {
  'wen': [
    { "specialty_code": 50101, "name": "汉语言文学", "is_wenli": "文科", "jihua": 1088, "baokao": 4467, "luqu": 1103, "批次": "本科一批", },
    { "specialty_code": 120203, "name": "会计学", "is_wenli": "文科", "jihua": 814, "baokao": 1174, "luqu": 825, "批次": "本科一批", },
    { "specialty_code": 501, "name": "中国语言文学类", "is_wenli": "文科", "jihua": 370, "baokao": 847, "luqu": 378, "批次": "本科一批", },
    { "specialty_code": 1202, "name": "工商管理类", "is_wenli": "文科", "jihua": 802, "baokao": 737, "luqu": 795, "批次": "本科一批", },
    { "specialty_code": 201, "name": "经济管理试验班", "is_wenli": "文科", "jihua": 53, "baokao": 713, "luqu": 58, "批次": "本科一批", },
    { "specialty_code": 301, "name": "法学类", "is_wenli": "文科", "jihua": 257, "baokao": 665, "luqu": 261, "批次": "本科一批", },
  ],
  'li': [
    { "specialty_code": "0600", "name": "工科试验班", "is_wenli": "理科", "jihua": 1632, "baokao": 7201, "luqu": 1666 },
    { "specialty_code": "0809", "name": "计算机类", "is_wenli": "理科", "jihua": 2152, "baokao": 7075, "luqu": 2261 },
    { "specialty_code": 80601, "name": "电气工程及其自动化", "is_wenli": "理科", "jihua": 1428, "baokao": 6915, "luqu": 1451 },
    { "specialty_code": 100201, "name": "临床医学", "is_wenli": "理科", "jihua": 2679, "baokao": 6526, "luqu": 2695 },
    { "specialty_code": "080902", "name": "软件工程", "is_wenli": "理科", "jihua": 3972, "baokao": 5347, "luqu": 4009 },
    { "specialty_code": "0807", "name": "电子信息类", "is_wenli": "理科", "jihua": 1484, "baokao": 4397, "luqu": 1551 },
  ]
}